import { EPlatformNoticeRecipientType } from "../../Enum/EPlatformNoticeRecipientType"

export class PlatformNoticeRecipient {
  recipientKey: string

  recipientType: EPlatformNoticeRecipientType

  companyId: number

  userId: string

  companyName: string

  slug: string

  constructor(data: Partial<PlatformNoticeRecipient> = {}) {
    this.recipientKey = data.recipientKey ?? data.userId ?? ""

    this.recipientType = data.recipientType ?? EPlatformNoticeRecipientType.Restaurant

    this.companyId = data.companyId ?? 0

    this.userId = data.userId ?? ""

    this.companyName = data.companyName ?? ""

    this.slug = data.slug ?? ""
  }
}
